<template>
    <tr class="entity-row-cs-36" v-if="!isDeleted">
        <td>

            <router-link :to="{ name: 'fire-stopping-report-view-item', params: {id: issue.site_fire_stopping_report_item_id} }" class="d-block">
                {{ issue.pin_number }} | {{ issue.issue_location }} </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'fire-stopping-report-view-item', params: {id: issue.site_fire_stopping_report_item_id} }" class="a-primary d-block">
                View </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'fire-stopping-report-edit-item', params: {id: issue.site_fire_stopping_report_item_id} }"  class="a-info d-block">Edit</router-link>
        </td>
        <td>
            <a class="a-positive d-block"
               v-bind:href="'#clone-issue-link-' + issue.site_fire_stopping_report_item_id"
               v-bind:id="'clone-issue-link-' + issue.site_fire_stopping_report_item_id"
               v-on:click="cloneItem"
               v-bind:data-item-id="issue.site_fire_stopping_report_item_id"
               ref="cloneButton"
            >Clone</a>
        </td>
        <td>
            <a class="a-danger delete-entity d-block"
               v-bind:href="'#delete-issue-link-' + issue.site_fire_stopping_report_item_id"
               v-bind:id="'delete-issue-link-' + issue.site_fire_stopping_report_item_id"
               v-on:click="deleteItem"
               v-bind:data-item-id="issue.site_fire_stopping_report_item_id"
               ref="deleteButton"
            >Delete</a>
        </td>
    </tr>
</template>
<script>
    export default {
        props: ['issue', 'fireStoppingReport'],
        data() {
            return {
                isDeleted: false,
                itemToDelete: null,
                itemToClone: null,
            }
        },
        methods: {
            deleteItem() {
                var button = this.$refs.deleteButton;
                var itemId = button.dataset.itemId;
                var vm = this;

                this.getDbNew().then(db => {
                    var reportItemId = parseInt(itemId);
                    var objectStore = db.transaction('fire_stopping_report_items').objectStore('fire_stopping_report_items');
                    var storeRequest = objectStore.get(reportItemId);

                    storeRequest.onsuccess = function(event) {
                        vm.itemToDelete = storeRequest.result;
                        vm.itemToDelete.is_deleted = true;

                        vm.$swal({
                            title: 'Are you sure?',
                            text: 'Are you sure you want to delete this issue?',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes',
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            buttons: {
                                cancel: {
                                    text: 'Cancel',
                                    value: null,
                                    visible: false,
                                    className: 'btn btn-square btn-sm btn-secondary',
                                    closeModal: true,
                                },
                                confirm: {
                                    text: 'Yes',
                                    value: true,
                                    visible: true,
                                    className: 'btn btn-square btn-sm btn-primary',
                                    closeModal: true
                                }
                            }
                        }).then((result) => {
                            if (result.value) {
                                var putRequest = db.transaction('fire_stopping_report_items', 'readwrite')
                                    .objectStore('fire_stopping_report_items').put(vm.itemToDelete);
                                putRequest.onsuccess = function(event) {
                                    vm.isDeleted = true;
                                };
                                putRequest.onerror = function(event) {
                                    console.log(event);
                                };
                            }
                        });
                    };
                    storeRequest.onerror = function(e) {
                        console.log(e)
                    }
                }).catch(e => {
                    console.log(e);
                });
            },
            cloneItem() {
                var button = this.$refs.deleteButton;
                var itemId = button.dataset.itemId;

                this.$swal({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to clone this issue?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true,
                    buttons: {
                        cancel: {
                            text: 'Cancel',
                            value: null,
                            visible: false,
                            className: 'btn btn-square btn-sm btn-secondary',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Yes',
                            value: true,
                            visible: true,
                            className: 'btn btn-square btn-sm btn-primary',
                            closeModal: true
                        }
                    }
                }).then((result) => {
                    if (result.value) {
                        this.getDbNew().then(db => {
                            var reportItemId = parseInt(itemId);
                            var objectStore = db.transaction('fire_stopping_report_items').objectStore('fire_stopping_report_items');
                            var storeRequest = objectStore.get(reportItemId);
                            var vm = this;

                            storeRequest.onsuccess = function(event) {
                                vm.itemToClone = storeRequest.result;
                                vm.itemToClone.site_fire_stopping_report_item_id = Math.floor(new Date().getTime() / 1000);

                                try {
                                    var highestMarkerNumber = null;
                                    objectStore.openCursor().onsuccess = function (event) {
                                        var cursor = event.target.result;

                                        if (cursor) {
                                            if(
                                                cursor.value.site_fire_stopping_report_id == vm.fireStoppingReport.site_fire_stopping_report_id && 
                                                (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined) &&
                                                cursor.value.pin_number &&
                                                (!highestMarkerNumber || highestMarkerNumber < cursor.value.pin_number)
                                            ) {
                                                highestMarkerNumber = cursor.value.pin_number;
                                            }
                                            cursor.continue();
                                        } else {
                                            vm.itemToClone.pin_number = highestMarkerNumber + 1;
                                            var putRequest = db.transaction('fire_stopping_report_items', 'readwrite')
                                                .objectStore('fire_stopping_report_items').put(vm.itemToClone);
                                            putRequest.onsuccess = function(event) {
                                                vm.reload();
                                            };
                                            putRequest.onerror = function(event) {
                                                console.log(event);
                                            };
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            };
                            storeRequest.onerror = function(e) {
                                console.log(e)
                            }
                        }).catch(e => {
                            console.log(e);
                        });
                    }
                });
            },
            reload() {
                window.location = '';
            }
        }
    }
</script>